import { camelCase, snakeCase } from "change-case";
import { useEffect, useState } from "react";

import { useSearchParams } from "@/hooks";

const ASC = "asc";
const DESC = "desc";

const parseSort = (value) => {
  if (!value) return;
  const regex = new RegExp(`(^.*)_(${DESC}|${ASC})$`, "i");
  const [, field, order] = value.match(regex) || [];

  if (!field || !order) return;
  return [camelCase(field), order.toLowerCase()];
};

const toSortingState = (sort, initialSort) => {
  const parsedSort = parseSort(sort);
  const parsedInitialSort = parseSort(initialSort);

  const value = parsedSort || parsedInitialSort;

  if (!value) return [];

  const [id, order] = value;
  return [{ id, desc: order === DESC }];
};

const fromSortingState = (value) => {
  if (!value.length) return "";
  const order = value[0].desc ? DESC : ASC;
  const field = snakeCase(value[0].id);
  return `${field}_${order}`;
};

export default function useSorting(initialSort) {
  const { setParams, getParam } = useSearchParams();
  const currentSort = getParam("sort");
  const sortingState = toSortingState(currentSort, initialSort);
  const [sorting, setSorting] = useState(sortingState);

  const isFirstSorting =
    !currentSort && fromSortingState(sorting) === initialSort.toLowerCase();

  useEffect(() => {
    if (isFirstSorting) return;

    if (sorting.length) {
      const sort = fromSortingState(sorting);
      if (currentSort !== sort) {
        setParams({ sort });
      }
    }
  }, [sorting]);

  return { sorting, onSortingChange: setSorting };
}
